import { render, staticRenderFns } from "./CapturePassport.vue?vue&type=template&id=38c44a3b&"
import script from "./CapturePassport.vue?vue&type=script&lang=ts&"
export * from "./CapturePassport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports